import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AccountType } from "../types";
import { Dispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { setAccount } from "../../dashboard/redux/accountSlice";
import useTailwindBreakpoints from "../../../hooks/useTailwindBreakPoints";
import { Text } from "../../core/design-system/Text";
import { Img } from "../../core/design-system/Img";

interface AccHaveProps {
  type?: string;
  accountsHave?: AccountType[];
  accountsOwe?: AccountType[];
  youHaveAmount?: string;
  youOweAmount?: string;
}

const AccountHave: React.FC<AccHaveProps> = ({
  type = "have",
  accountsHave = [],
  accountsOwe = [],
  youHaveAmount = "",
  youOweAmount = "",
}) => {
  const dispatch: Dispatch = useDispatch();
  const navigate = useNavigate();

  const navToAccount = (account: AccountType) => {
    dispatch(
      setAccount({
        label: account.name,
        value: { ...account },
        account_type: type,
      })
    );
    navigate(`account/${account.id}`);
  };

  useEffect(() => {
    populateAccounts();
  }, []);

  const populateAccounts = () => {
    // Populate accounts logic
  };

  const displayAccounts = type === "owing" ? accountsOwe : accountsHave;
  const { md, lg } = useTailwindBreakpoints();

  const getItemsPerDimension = (displayAccounts: any): any[] => {
    if (displayAccounts.length === 1 && lg) {
      return [...displayAccounts, { id: "empty" }];
    }
    if (!lg) return displayAccounts.slice(0, 1);
    else return displayAccounts.slice(0, 2);
  };
  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-row pl-[1.396rem] pr-[1.027rem] py-[0.8rem] border border-lightGray rounded-t-xl border-b-0">
        <div className="flex flex-col gap-[0.3rem]">
          <Text className="!text-darkGray  font-medium xs:text-xs sm:text-md 5xl:text-xl flex-none order-none grow-0 text-left align-text-bottom m-0">
            {type !== "owing" ? "You have" : "You owe"}
          </Text>
          <Text className="!text-gray-50_04  xs:text-2xs xsSm:text-2xs sm:text-lg 5xl:text-2xl ml-auto text-left 5xl:font-normal">
            {!md ? `${youHaveAmount.slice(0, 10)}...` : youHaveAmount}
          </Text>
        </div>
        <Img
          src={type !== "owing" ? "piggyBank.png" : "img_tax_1.png"}
          alt="piggyBank"
          className="ml-auto xs:size-[1.5rem] xsSm:size-[2rem] md:w-[2.645rem] xs:h-[3.063rem] md:h-[3.2rem]"
        />
      </div>
      <div
        className={`flex flex-col gap-[0.5rem] pb-[0.8rem] ${
          type !== "owing" ? "bg-ah1" : "bg-ah2"
        } rounded-b-xl pt-[1rem] px-[1.396rem]`}
      >
        <div className="flex flex-col gap-[0.5rem]">
          {getItemsPerDimension(displayAccounts).map((account) => {
            if (account.id === "empty") {
              return (
                <div
                  key="empty"
                  className="flex flex-col gap-[0.2rem] justify-start border  border-x-0 border-t-0 border-dashed border-opacity-20 border-white-A700 xs:pb-[3.5rem] 5xl:pb-[4.8rem] "
                ></div>
              );
            }
            return (
              <button
                key={account.id}
                className="flex flex-col gap-[0.2rem] justify-start border  border-x-0 border-t-0 border-dashed border-opacity-20 border-white-A700 pb-[0.8rem] hover:cursor-pointer"
                onClick={() => navToAccount(account)}
              >
                <div className="flex flex-row justify-between w-full">
                  <Text className="text-white-A700 xs:text-2xs xslg:text-sm 5xl:text-xl xs:font-medium 5xl:font-normal">
                    {!md
                      ? `${account?.balanceLcyFormatted.slice(0, 10)}...`
                      : account?.balanceLcyFormatted}
                  </Text>
                  <Img
                    src="img_arrow_right_white.svg"
                    alt="tax"
                    className="size-[1rem]"
                  />
                </div>
                <Text className="text-white-A700 text-opacity-50 xs:font-medium  5xl:text-xl xs:text-2xs  xslg:text-xs text-left 5xl:font-normal">
                  {type === "owing"
                    ? account.name
                    : ` ****
                ${account.id
                  .slice(30, account.id?.length)
                  .toLocaleUpperCase()}`}
                </Text>
              </button>
            );
          })}
        </div>
        <Text className="text-white-A700 xs:font-medium 5xl:font-normal xs:text-2xs xslg:text-xs 5xl:text-lg text-center">
          View all accounts
        </Text>
      </div>
    </div>
  );
};

export default AccountHave;
